import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { Layout, WizardFooter, Card, MainLoader, Heading, ActionButton, ExternalLink, FormFieldInputNew, useForm, Text, Button } from "@netapp/bxp-design-system-react";
import styles from "./NoOrgDialog.module.scss";
import { setItemAnon } from "utils/localstorage";
import * as yup from 'yup';
import { appComponents as i18nNamespace } from "../../../i18n/namespace";
import { useTranslation } from "react-i18next";
import { ReactComponent as OrgImage } from './Organisation.svg';

const useorgFormSchema= (t) => {
    return  yup.object().shape({
    orgName: yup
        .string()
        .matches(
            /^.{1,300}$/,
            t("enter_name"),
          )
        .required(t("organization_name_required"))
});
}

const getStartedUrl = 'https://docs.netapp.com/us-en/bluexp-setup-admin/task-iam-get-started.html'

export default React.memo(() => {
    const {isReloading, isCreatingAccount, userCompany, name, errMessage} = useSelector((state) => ({
                                                                            isReloading: state.app.isReloading,
                                                                            isCreatingAccount: state.tenancy?.creatingAccount,
                                                                            errMessage: state.tenancy?.errMessage,
                                                                            userCompany: state.tenancy?.user?.company,
                                                                            name: state.auth.firstName
                                                                            }));
    const dispatch = useDispatch();
    const [isPending, setIsPending] = useState(true);
    const {t} = useTranslation(i18nNamespace);
    const orgFormSchema = useorgFormSchema(t);
    const form = useForm({orgName: ''}, orgFormSchema);
    const { isValid, handleFormSubmit, formState } = form;

    useEffect(() => {
        if (userCompany) {
            form.handleFormChange(userCompany, {name: 'orgName'});
        }
        setIsPending(false);
    }, [userCompany]);

    const createOrganization = () => {
        setItemAnon({itemKey: `dontShowNewBlue`}, true)
        dispatch({
            type: 'TENANCYV4:CREATE-ORGANIZATION',
            payload: {
                organizationName: formState.orgName,
                resourceType: "organization",
                resourceClass: "hierarchy",
                version: "1.0",
                type : "application/vnd.netapp.bxp.resource",
            }
        });
    };

    if(isReloading) {
        return <MainLoader/>
    }

    return <>
        <Layout.Page>
            <Layout.Content>
                <Layout.Container className={styles['layout-container']}>
                    <Layout.Grid centerContent>
                        <Layout.GridItem>
                            <div className={styles['centered-flex-container']}>
                                <OrgImage/>
                                <Card className={styles.cardBase}>
                                    <Heading level="24" bold='true'>{t("welcome")} {name}</Heading>
                                    <br />
                                    <Text bold level="16">{t("create_organization")}</Text>
                                    <br />
                                    <Text level="14">{t("top_level_element")}</Text>
                                    <br />
                                    <ExternalLink variant="text" href={getStartedUrl} includeArrow={true}>{t("learn_more_about_organizations")}</ExternalLink>
                                    <br /><br />
                                    <FormFieldInputNew
                                        name="orgName"
                                        label={t("organization_name")}
                                        disabled={isCreatingAccount}
                                        form={form}
                                        autoComplete="off"
                                        pending={isPending}
                                        showError={!!errMessage}
                                        errorMessage={errMessage}
                                    />

                                    <br />
                                    <div className={styles.infoSection}>
                                        <Text level="14">{t("enable_key_workflows")}</Text>
                                        <br />
                                        <ExternalLink variant="text" onClick={() => dispatch({
                                            type: "SUPPORT:ADD-NSS-OPEN-POPOVER"
                                        })} style={{ cursor: 'pointer' }} includeArrow={false}>{t("netapp_support_site_account")}</ExternalLink>
                                    </div>
                                    <Button className={styles['create-button']} disabled={!isValid} onClick={handleFormSubmit(createOrganization)} isSubmitting={isCreatingAccount}>{t("create")}</Button>
                                </Card>
                            </div>
                        </Layout.GridItem>
                    </Layout.Grid>
                </Layout.Container>
            </Layout.Content>
        </Layout.Page>
    </>
})